import { ref, getCurrentInstance } from 'vue'
/**
 * 兼容老组件的 beforValueActions，必须传入 props.store 和 props.beforValueAction
 * @param {object} options 配置
 *
 * @returns
 */

export function useDispatch() {
  const { proxy } = getCurrentInstance()
  return {
    dispatch(componentName, eventName, params) {
      let parent = proxy.$parent || proxy.$root
      let name = parent.$options?.name
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options?.name
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
  }
}

export function useBeforValueOldActions({ store, beforValueAction, emit }) {
  const loading = ref(false)
  /**
   * 前置钩子 Emit
   *
   * @param {object} val 传递给前置钩子函数（beforValueAction.name）的值
   * @returns {booelan} flag 返回结果
   */
  const beforeEmit = async (val) => {
    let flag = true

    console.log('store: ', store)
    console.log('beforValueAction: ', beforValueAction)

    if (beforValueAction && beforValueAction.type == 'mutations' && store) {
      store.commit(
        beforValueAction.name,
        val,
        beforValueAction.dataIndex,
        beforValueAction.extendData
      )
    } else if (beforValueAction && beforValueAction.type == 'actions' && store) {
      loading.value = true
      flag = await store.dispatch(
        beforValueAction.name,
        val,
        beforValueAction.dataIndex,
        beforValueAction.extendData
      )
      loading.value = false
    }
    if (flag?.type) {
      emit?.('input', flag?.val)
    } else if (flag) emit?.('input', val)
    return flag
  }

  return {
    loading,
    beforeEmit,
  }
}

export const beforValueOldActionProps = {
  store: { type: Object },
  beforValueAction: {
    type: Object,
    default: null,
  },
}
